import React from 'react';
import styled from 'styled-components';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';

import { CardTemplateRectangleShape, CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { CardRectangleShape, CardShapeDb } from '../redux/cardShapeDbSlice';

type ShapeSvgProps = {
  x: number;
  y: number;
  rotation: number;
  selecting?: boolean;
}
const ShapeSvg = styled.svg<ShapeSvgProps>`
  position: absolute;
  border: ${props => props.selecting ? '1px solid blue' : undefined};
  box-sizing: border-box;
  transform: ${props => 'translate(' + props.x + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg) !important'};
  transform-origin: center;
`
type RectangleRectProps = {
  strokeProps: {display: boolean, color: string, opacity: number, width: number};
  fillProps: {display: boolean, color: string, opacity: number};
}
const RectangleRect = styled.rect<RectangleRectProps>`
  stroke: ${props => props.strokeProps.color};
  stroke-opacity: ${props => props.strokeProps.display ? props.strokeProps.opacity : 0};
  stroke-width: ${props => props.strokeProps.width};
  fill: ${props => props.fillProps.color};
  fill-opacity: ${props => props.fillProps.display ? props.fillProps.opacity : 0};
`

type RectangleShapeProps = {
  id?: string;
  item: CardTemplateRectangleShape | CardRectangleShape;
  setSelectingId?: (id: string | undefined) => void;
  dragItem?: (data: DraggableData, item: CardTemplateShapeDb | CardShapeDb, id: string) => void;
  scaleValue?: number;
  selecting?: boolean;
}
const RectangleShape: React.FC<RectangleShapeProps> = ({id, item, setSelectingId, dragItem, scaleValue, selecting}) => {
  const stroke = selecting ? {...item.stroke, width: item.stroke.width - 1} : item.stroke;
  let width = stroke.display ? item.width - stroke.width : item.width;
  let height = stroke.display ? item.height - stroke.width : item.height;
  if (selecting) {
    width -= 2;
    height -= 2;
  }

  return (
    <Draggable position={{x: item.x, y: item.y}}
      onStart={() => setSelectingId ? setSelectingId(id) : undefined}
      onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem && id ? dragItem(data, item, id) : undefined}
      scale={scaleValue} disabled={!id}>
      <ShapeSvg width={item.width} height={item.height}
        x={item.x} y={item.y} rotation={item.rotation} selecting={selecting}
        xmlns="http://www.w3.org/2000/svg">
        <RectangleRect width={width} height={height} x={stroke.width / 2} y={stroke.width / 2}
          strokeProps={stroke} fillProps={item.fill} />
      </ShapeSvg>
    </Draggable>
  );
}

export default RectangleShape;
